import {roomKey} from './roomBoardMutation';

// Only the lock-owned, currently active stay can restore a missing/Ready card.
// The caller must read board, lock and stay inside the same transaction.
export function restoreOccupiedRoom(board, lock, stay, {hotelId, room, stayId}) {
  if (!hotelId || !room || !stayId || lock?.hotelId !== hotelId ||
      roomKey(lock) !== room || String(lock.activeStayId || '') !== stayId ||
      stay?.hotelId !== hotelId || roomKey(stay) !== room ||
      String(stay.status || '').trim().toLowerCase() !== 'checked_in' ||
      stay.checkedOut === true || stay.checkoutCompleted === true ||
      (board.hotelId && board.hotelId !== hotelId)) {
    throw new Error('Existing stay/room lock match nahi hua. Recovery roki gayi; koi guest record change nahi hua.');
  }
  const occupied = (board.occupiedRooms || []).find(item => roomKey(item) === room);
  if (occupied && !occupied.detailsPending && String(occupied.stayId || occupied.id || '') !== stayId) {
    throw new Error('Board par doosra guest hai. Pehle stay verify karein.');
  }
  const checkout = (board.checkoutRooms || []).find(item => roomKey(item) === room);
  if (checkout) throw new Error('Room par checkout/cleaning card hai. Pehle lifecycle verify karein.');
  const category = stay.category || stay.roomCategory || occupied?.category || occupied?.roomCategory || '';
  const card = {...occupied, ...stay, id: stayId, stayId, room,
    status: 'checked_in', detailsPending: false, category, roomCategory: category};
  return {...board,
    vacantRooms: (board.vacantRooms || []).filter(item => roomKey(item) !== room),
    occupiedRooms: [...(board.occupiedRooms || []).filter(item => roomKey(item) !== room), card],
    checkoutRooms: board.checkoutRooms || [], serviceRooms: board.serviceRooms || []};
}

// Closed stays retain their history. Restore only their board/cleaning state.
export function restoreClosedRoom(board, lock, stay, task, {hotelId, room, stayId, previousStay = null, previousStayId = ''}) {
  if (!hotelId || !room || !stayId || lock?.hotelId !== hotelId || roomKey(lock) !== room ||
      String(lock.activeStayId || lock.lastStayId || '') !== stayId ||
      stay?.hotelId !== hotelId || roomKey(stay) !== room ||
      stay.checkedOut !== true || stay.checkoutCompleted !== true ||
      !(stay.actualCheckOutAt || stay.checkedOutAt) || (board.hotelId && board.hotelId !== hotelId)) {
    throw new Error('Completed checkout aur room lock verify nahi hue. Koi record change nahi hua.');
  }
  const occupied = (board.occupiedRooms || []).find(item => roomKey(item) === room);
  const checkout = (board.checkoutRooms || []).find(item => roomKey(item) === room);
  for (const card of [occupied, checkout]) {
    if (card && !card.detailsPending && String(card.stayId || card.id || '') !== stayId)
      throw new Error('Room par doosra guest/cleaning card hai. Recovery roki gayi.');
  }
  let archivedTask = null;
  if (task && String(task.stayId || '') !== stayId) {
    const previousCheckout = Date.parse(previousStay?.actualCheckOutAt || previousStay?.checkedOutAt || '');
    const taskCheckout = Date.parse(task.actualCheckOutAt || task.checkedOutAt || task.checkoutAt || '');
    const currentCheckIn = Date.parse(stay.checkInAt || '');
    if (task.hotelId !== hotelId || roomKey(task) !== room || !task.stayId ||
        previousStayId !== String(task.stayId) || previousStay?.hotelId !== hotelId || roomKey(previousStay) !== room ||
        previousStay.checkedOut !== true || previousStay.checkoutCompleted !== true || previousStay.status !== 'checked_out' ||
        task.status !== 'completed' || task.roomReady !== true || task.maintenanceRequired === true ||
        !Number.isFinite(previousCheckout) || !Number.isFinite(currentCheckIn) ||
        previousCheckout !== taskCheckout || previousCheckout > currentCheckIn) {
      throw new Error('Room par doosra housekeeping task hai. Purane stay ka completed checkout verify nahi hua; recovery roki gayi.');
    }
    // Caller preserves the full old task in the same transaction's audit entry.
    // Old cleaning never marks the later guest's room Ready.
    archivedTask = task;
    task = null;
  }
  if (task && (task.hotelId !== hotelId || roomKey(task) !== room))
    throw new Error('Housekeeping hotel/room mismatch hai. Recovery roki gayi.');
  const category = stay.category || stay.roomCategory || occupied?.category || checkout?.category || '';
  const maintenance = task?.maintenanceRequired === true || checkout?.maintenanceRequired === true || lock.status === 'maintenance_hold';
  const ready = !maintenance && task?.roomReady === true && task?.status === 'completed';
  const checkoutAt = stay.actualCheckOutAt || stay.checkedOutAt;
  const card = {...checkout, room, stayId, category, roomCategory: category,
    guestName: stay.guestName || '', status: maintenance ? 'maintenance_hold' : 'checkout_pending',
    cleaningStatus: task?.cleaningStatus || 'pending', maintenanceRequired: maintenance,
    roomReady: false, checkoutAt, checkedOutAt: checkoutAt, source: 'completed_checkout_recovery'};
  const next = {...board,
    occupiedRooms: (board.occupiedRooms || []).filter(item => roomKey(item) !== room),
    vacantRooms: [...(board.vacantRooms || []).filter(item => roomKey(item) !== room), ...(ready ? [{room, category, roomCategory: category}] : [])],
    checkoutRooms: [...(board.checkoutRooms || []).filter(item => roomKey(item) !== room), ...(ready ? [] : [card])],
    serviceRooms: ready ? (board.serviceRooms || []).filter(item => roomKey(item) !== room) : (board.serviceRooms || [])};
  return {board: next, ready, maintenance, archivedTask, task: task || {
    hotelId, room, stayId, guestName: stay.guestName || '', checkedOutAt: checkoutAt,
    status: 'pending', cleaningStatus: 'pending', roomReady: false, maintenanceRequired: maintenance,
    cleaningChecklist: {}, assignedTo: ''}};
}
